// extracted by mini-css-extract-plugin
var _1 = "CalendarGridAgenda-moduleCalendarGridAgenda__pkViH";
var _2 = "CalendarGridAgenda-moduleempty__Qj2l5 CalendarGridBodyMessage-moduleCalendarGridBodyMessage__w70n9";
export { _1 as "CalendarGridAgenda", _2 as "empty" }
